import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/enviroments';

@Injectable({
  providedIn: 'root'
})
export class DocumentTemplateApiCallerService {

  constructor(private http: HttpClient) {}

  getDocumentTemplates(): Observable<Array<DocumentTemplate>> {
    const endpoint = `${environment.apiUrl}/DocumentTemplate`;
    return this.http.get<Array<DocumentTemplate>>(endpoint);
  }

  getDocumentTemplate(id:number): Observable<DocumentTemplate> {
    const endpoint = `${environment.apiUrl}/DocumentTemplate/${id}`;
    return this.http.get<DocumentTemplate>(endpoint);
  }

  createDocumentTemplate(request: DocumentTemplate): Observable<any> {
    const endpoint = `${environment.apiUrl}/DocumentTemplate`;
    return this.http.post<any>(endpoint, request);
  }

  deleteDocumentTemplate(id: number, newStatus: boolean): Observable<any> {
    const endpoint = `${environment.apiUrl}/DocumentTemplate/${id}/ChangueStatus?newStatus=${newStatus}`;
    return this.http.put<any>(endpoint, {});
  }
  
  getTemplateVariables(): Observable<DocumentTemplateVariable[]> {
    const endpoint = `${environment.apiUrl}/DocumentTemplate/variables`;
    return this.http.get<DocumentTemplateVariable[]>(endpoint);
  }

  asingUseDocumentTemplate(id: number, used: number, forceChangue: boolean): Observable<any> {
    const endpoint = `${environment.apiUrl}/DocumentTemplate/${id}/AsingUsedDocumentTemplate?used=${used}&forceChangue=${forceChangue}`;
    const body = { used, forceChangue };
    return this.http.put<any>(endpoint, body);
  }  

  downloadDocumentPreVisualizacion(templateId: number): Observable<any> {
    const endpoint = `${environment.apiUrl}/DocumentTemplate/documents/${templateId}/download`;
    return this.http.get(endpoint, {responseType: 'blob'});
  }

  downloadDocumentDraft(used: number, companyId: number): Observable<any> {
    const endpoint = `${environment.apiUrl}/DocumentTemplate/GenerateDocumentPDFDraft?typeUse=${used}&companyId=${companyId}`;
    return this.http.post<any>(endpoint, {}); 
  }  

  generateDocumentClient(used: number, companyId: number, signatureType: number): Observable<any> {
    const endpoint = `${environment.apiUrl}/DocumentTemplate/GenerateDocumentsClients?typeUse=${used}&companyId=${companyId}&signature=true&signatureType=${signatureType}`;
    return this.http.post<any>(endpoint, {}); 
  }  

  getUsesDocumenTemplates(): Observable<UsedTemplateDocuments[]> {
    const endpoint = `${environment.apiUrl}/DocumentTemplate/Documents/Uses`;
    return this.http.get<UsedTemplateDocuments[]>(endpoint);
  }

}

export interface DocumentTemplateVariable {
  variableId: number;
  name: string;
  description: string;
  isIterable: boolean;
  relatedVariableId: number | null;
}

export interface DocumentTemplate {
  templateId: number;
  name: string;
  description: string;
  htmlTemplate: string;
  txtTemplate: string;
  categoryName: string;
  categoryId: number;
  createdAt: Date;
  modifiedAt: Date;
  modifiedBy: string;
  used: UsedTemplate;
  jsonConfig: JsonConfig;
}

export interface JsonConfig {
  size: number;
  orientation: number;
}

export interface UsedTemplateDocuments {
  idUsed: number;
  name: string;
  description: string;
  typeName?: string;
}

export enum UsedTemplate
{
  Sin_Uso,
  Contrato_cliente_FORMULA,
  Contrato_cliente_persona_INGE_SAGR,
  Contrato_cliente_empresa_INGE_SAGR,
  Poliza_de_garantia_RENTA_NACIONAL,
  Poliza_de_garantia_CESCE,
  Certificado_de_garantia_INGE_SAGR,
  Contrafianza_CESCE,
  Ficha_UAF,
}